import React from 'react';
import { Animated, TouchableOpacity } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text, Icon } from '..';
function Option({ value, name, iconName, onClick, animValue, offset }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(TouchableOpacity, { onPress: () => {
            onClick(value);
        }, style: styles.container },
        React.createElement(Animated.View, { style: [
                styles.row,
                {
                    opacity: animValue.interpolate({
                        inputRange: [0, offset / 3, (2 * offset) / 3],
                        outputRange: value === 'light'
                            ? [1, 0.56, 0.56]
                            : value === 'dark'
                                ? [0.56, 1, 0.56]
                                : [0.56, 0.56, 1],
                        extrapolate: 'clamp'
                    })
                }
            ] },
            React.createElement(Icon, { name: iconName }),
            React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular', style: styles.text }, name))));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: { flex: 1 },
    text: { color: color.invert2.p100, marginLeft: size.B },
    row: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
export default Option;
//# sourceMappingURL=Option.js.map